import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { makeCurrencyMask } from '@app/functions';
import { CompanyAdditionalIncome } from '@app/models/payroll/company-additional-income.model';
import { EmployeeAdditionalIncome } from '@app/models/payroll/employee-additional-income.model';
import { NotifyService } from '@app/services';
import { Locale } from '@app/types/translatable.type';
import { BaseForm } from '@forms/base.form';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-edit-additional-income',
    templateUrl: './edit-additional-income.template.html',
})
export class EditAdditionalIncomeForm extends BaseForm {
    @ViewChild('form') form: NgForm;
    @Input() modalContainer;
    @Input() pendingPayrollExists = false;
    @Input() companyAdditionalIncomes: CompanyAdditionalIncome[] = [];

    currencyMask = makeCurrencyMask({}, this.translateService.currentLang as Locale);

    constructor(
        private notify: NotifyService,
        private translateService: TranslateService
    ) {
        super();
    }

    get noIncomeTypesLeft(): boolean {
        return !this.companyAdditionalIncomes.some(
            ({ employeeAdditionalIncomes }) => employeeAdditionalIncomes[0]?.active
        );
    }

    async onRemove(employeeAdditionalIncome: EmployeeAdditionalIncome): Promise<void> {
        try {
            employeeAdditionalIncome.amount = 0;
            employeeAdditionalIncome.active = false;
            if (this.noIncomeTypesLeft) {
                this.modalContainer.deny();
            }

            await employeeAdditionalIncome.save();
            this.notify.success('employees.jobAndPay.removedIncomeType');
        } catch (err) {
            employeeAdditionalIncome.revert();
            this.notify.error('employees.jobAndPay.couldNotRemoveIncomeType');
        }
    }
}
